// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2e789839","455":"6f813e27","977":"83d242a6"}[chunkId] + ".chunk.js";
};